module.exports = __webpack_public_path__ + "media/bootstrap-icons/backspace-268e96b7.svg";